import { Link, useOutletContext } from "react-router-dom"
import { ServiceTile } from "../components/ServiceTile";
import { formatDate } from "../services/helpers";


export function MemberDetailsServices(){
	const contextData = useOutletContext();
	const services = contextData.services.service_tickets;
	return (
		<>
		{services.length === 0 && <h1>No service history added</h1>}
		{/* {services.map(service => (
			<ServiceTile key={service.ticket_id} service={service} />
		))} */}
		<table>
					<thead>
						<th>Vehicle</th>
						<th>Service Date</th>
						<th>Invoice Total</th>
						<th>Status</th>
						<th>Actions</th>
					</thead>
					<tbody>
						{services.map(service=>
							<tr>
								<td>{service.vehicle_name ? <>{service.vehicle_name} <small>({service.license_plate})</small></> : "Order Ticket"}</td>
								<td>{formatDate(service.date_created,false)}</td>
								{/* <td>Last Updated: {formatDate(service.date_updated)}</td> */}
								<td><strong >GHS</strong> <span className={service.total_paid < service.total_invoice ? "red-text" : "blue-text"}>{service.total_paid}</span> <strong>/{service.total_invoice ?? 0}</strong></td>
								<td><span className={`status-card ${service.status?.replaceAll(" ","-")}`}>{service.status}</span></td>
								<td>
									<Link className="" to={service.ticket_type === "service" ? `/dashboard/services/${service.license_plate}/${service.ticket_id}` : `/dashboard/members/u/${service.customer_id}/${service.ticket_id}`}>Details </Link>
								</td>
							</tr>
						)}
					</tbody>
				</table>
	</>
	)
}